"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAdditionalContextValue = void 0;
const react_1 = require("react");
const useAdditionalContextValue = (platform) => {
    const [actionsHeight, setActionsHeight] = (0, react_1.useState)(0);
    const [bodyGreed, setBodyGreed] = (0, react_1.useState)(false);
    const isMobile = platform === 'mobile';
    const isDesktop = platform === 'desktop';
    const isResponsive = platform === undefined;
    const contextValue = (0, react_1.useMemo)(() => ({
        actionsHeight,
        setActionsHeight,
        bodyGreed,
        setBodyGreed,
        platform,
        isMobile,
        isDesktop,
        isResponsive,
    }), [actionsHeight, bodyGreed, isDesktop, isMobile, isResponsive, platform]);
    return contextValue;
};
exports.useAdditionalContextValue = useAdditionalContextValue;
